module.exports = __webpack_public_path__ + "img/Logo_white.6a3e3e48.svg";